// extracted by mini-css-extract-plugin
export default {"participating_companies_container":"ParticipatingCompanies_participating_companies_container__z9fem"};